import React from "react";
import { StyledSvgIcon } from "../icon.styles";
import { customIconsPropTypes } from './customicons.propTypes';

const WindShieldOutlinedIcon = ({
  fontSize,
  color,
  backgroundColor,
  title,
  backgroundShape,
  theme,
}) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
  >
    <svg viewBox="0 0 31 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30.9273 15.5025L27.4151 1.29796C27.3299 0.955633 27.1261 0.655801 26.8411 0.453142C26.556 0.250484 26.2086 0.158502 25.8623 0.193973C23.9175 0.40005 18.6058 0.782764 15.5 0.782764C12.3942 0.782764 7.08249 0.40005 5.13775 0.193973C4.79139 0.158502 4.444 0.250484 4.15894 0.453142C3.87388 0.655801 3.67013 0.955633 3.58486 1.29796L0.0727273 15.5025C-0.00422762 15.7969 -0.0203236 16.1042 0.025451 16.4051C0.0712255 16.7061 0.177881 16.9942 0.338714 17.2513C0.499547 17.5084 0.711081 17.729 0.960021 17.8992C1.20896 18.0695 1.48993 18.1856 1.78526 18.2404C6.32616 18.9115 10.9113 19.2265 15.5 19.1825C20.0887 19.2265 24.6738 18.9115 29.2147 18.2404C29.5101 18.1856 29.791 18.0695 30.04 17.8992C30.2889 17.729 30.5005 17.5084 30.6613 17.2513C30.8221 16.9942 30.9288 16.7061 30.9745 16.4051C31.0203 16.1042 31.0042 15.7969 30.9273 15.5025ZM15.5 16.2385C11.3473 16.2796 7.19665 16.0337 3.07691 15.5025L6.06658 3.25568C8.24352 3.46176 12.8296 3.72672 15.5 3.72672C18.1704 3.72672 22.7565 3.46176 24.9334 3.25568L27.9231 15.5025C23.8033 16.0337 19.6527 16.2796 15.5 16.2385Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);

export default WindShieldOutlinedIcon;
WindShieldOutlinedIcon.propTypes = customIconsPropTypes;
